// @flow

// === Actions, keys
export const KEY_CURRENT_APP = 'app_current';
// Company branding page keys
export const KEY_CBP_APP_ID  = 'company_app_id';
export const KEY_CBP_HASH_ID = 'hash_id';

// Helper functions
const storageHelper = {

  // Set localStorage item
  setItem: (key: string, value: any) => {
    if( key === '' ) return false;
    localStorage.setItem(key, JSON.stringify(value));
  },

  // Remove item
  removeItem: (key: string = '') => {
    if( key === '' ) return false;
    localStorage.removeItem(key);
  },

  // Get item
  getItem: (key: string = '') => {
    if( key === ''|| key === null || key === undefined ) return false;
    let val = localStorage.getItem(key);
    if( val === null || val === undefined ) return false;

    try {
      return JSON.parse(val.toString());
    } catch(e) {
      return val.toString();
    }
  },

  // Clear whole localstorage
  destroyStorage: () => {
    localStorage.clear();
  }

}

export default storageHelper;



// WEBPACK FOOTER //
// ./src/helpers/storage.helper.js